/* eslint-disable jsx-a11y/anchor-is-valid */
import { nanoid } from 'nanoid';
import React, { useEffect, useState } from 'react';
import { DebounceInput } from 'react-debounce-input';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';
import { KTSVG } from '../../../_metronic/helpers';
import numberFormat from '../../helpers/numberFormat';
import parseCardDate from '../../helpers/parseCardDate';
import { IInvoices } from '../../modules/accounts/components/settings/SettingsModel';
import { useAuth } from '../../modules/auth';
import { getAllInvoices } from '../services/_accounts-requests';

const BillingHistory: React.FC = () => {
  const { auth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const [invoices, setInvoices] = useState<IInvoices[] | []>([]);
  const [query, setQuery] = useState('');
  // pagination state
  const items = invoices;
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(100);
  const [page, setPage] = useState(1);
  // pagination state

  useEffect(() => {
    getAllInvoices(auth!.api_token, query, page, itemsPerPage)
      .then((r) => {
        setInvoices(r.data.data);
        setItemsPerPage(r.data.per_page);
        setPageCount(r.data.last_page);
        if (r.data.lastQuery) {
          setPageCount(1);
          setPage(1);
          setItemOffset(0);
        }
      })
      .catch((err) => {
        const res = err.response;
        setError(res.data.message);
      });
  }, [query, page]);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    // @ts-ignore
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  const handlePageClick = (event: any) => {
    console.log(event);
    const newOffset = (event.selected * itemsPerPage) % items.length;
    setItemOffset(newOffset);
    setPage(event.selected + 1);
  };

  return (
    <div className="row d-flex justify-content-center">
      <div className="col-xl-6 col-lg-12 col-md-10 col-xs-12">
        <div className="flex-row-fluid shadow-sm rounded p-5 card mx-auto">
          <div
            className="fs-6 fw-bold cursor-pointer d-inline pb-5"
            onClick={() => navigate('/companies')}
          >
            <span className="menu-icon">
              <KTSVG
                path="/media/icons/duotune/arrows/arr063.svg"
                className="svg-icon-3x"
                svgClassName=""
              />
            </span>
            <span className="fs-2 fw-bold ms-3">Billing History</span>
          </div>
          <div>
            <table className="table gs-7 gy-7 gx-7 overflow-scroll table-row-bordered align-middle mb-5 text-center">
              <thead>
                <tr className="fw-bold fs-6 text-gray-800 border-bottom border-gray-200">
                  <th className="text-start">Description</th>
                  <th>Total</th>
                  <th className="text-center">Download</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((el) => {
                  return (
                    <tr key={nanoid()} className="">
                      <td className="text-start fw-semibold">
                        {el.description}
                        <br />
                        <span className="text-muted">
                          {parseCardDate(el.created_at)}
                        </span>
                      </td>
                      <td>
                        {el.currency_symbol}
                        {numberFormat(el.amount_paid / 100)}
                      </td>
                      <td>
                        <a
                          href={el.invoice_pdf}
                          className="btn btn-light btn-active-light-primary mx-auto p-0 d-flex align-items-center justify-content-center"
                          style={{ width: '35px', height: '35px' }}
                        >
                          <KTSVG
                            path="/media/icons/duotune/arrows/arr065.svg"
                            className="svg-icon-1x m-0"
                            svgClassName=""
                          />
                        </a>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>

            {error && (
              <div className="fv-plugins-message-container mb-5 text-center">
                <div className="fv-help-block">
                  <span role="alert">{error}</span>
                </div>
              </div>
            )}

            <ReactPaginate
              breakLabel="..."
              nextLabel=">"
              onPageChange={handlePageClick}
              pageRangeDisplayed={5}
              pageCount={pageCount}
              previousLabel="<"
              className="pagination align-items-center"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              activeClassName="active"
              previousClassName="previous me-2 fs-1"
              nextClassName="next ms-2 fs-1"
              disabledClassName="disabled"
              disabledLinkClassName="disabled"
              // renderOnZeroPageCount={null}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BillingHistory;
